[
  {
    "name": "Consultus",
    "layouts": [
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__hero-header",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-spill-right",
                "type": "custom"
              },
              {
                "class": "px-4",
                "icon": "SM",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__column-media-grow",
                "type": "custom"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":10}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h1>Life is better</h1>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"\",\"alt\":\"\",\"aspectRatio\":{\"height\":0,\"width\":0},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/assets/at-home-header.png?aspect-ratio=433%3A107\",\"newTab\":false,\"objectFit\":\"\",\"width\":\"350\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Looking for care?\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__yellow\",\"textColour\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"\",\"buttonText\":\"Become a carer\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__peach\",\"textColour\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"\",\"alt\":\"\",\"aspectRatio\":{\"height\":0,\"width\":0},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/assets/trust-pilot-header.png?aspect-ratio=531%3A121\",\"newTab\":false,\"objectFit\":\"\",\"width\":\"280\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":40}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"image\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Container%20concepts%20v3.png?aspect-ratio=4%3A3\",\"overlayImage\":\"/files/image%20overlays/consultus_test.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20005550%20-%20Design.svg\",\"xRatio\":4,\"yRatio\":3}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "hero",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__hero-header",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-spill-right",
                "type": "custom"
              },
              {
                "class": "px-4",
                "icon": "SM",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__column-media-grow",
                "type": "custom"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "two-columns"
          }
        },
        "id": "7ec438bc-207c-481e-9c7e-843cde84aa39"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-spill-left",
                "type": "custom"
              }
            ],
            "fontColour": "var(--dark-green)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Left-image-overlays/HEX%20FDE9E3%20-%20Design%203.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20FDE9E3%20-%20Design.svg\",\"xRatio\":4,\"yRatio\":2.2}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h1>What is live-in care?</h1>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "secondary_hero",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-spill-left",
                "type": "custom"
              }
            ],
            "fontColour": "var(--dark-green)",
            "layout": "two-columns"
          }
        },
        "id": "f5a9c3a7-7382-4bd0-ad37-926c11541eb0"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-spill-left",
                "type": "custom"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Left-image-overlays/Design%20A%20-%20Desktop%20Image%20Only_RIGHT%20SIDE_6.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20005550%20-%20Design.svg\",\"xRatio\":4,\"yRatio\":2.2}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h1>Nursing care services</h1>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "secondary_hero_alt",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-spill-left",
                "type": "custom"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "id": "9ebc3914-4659-4f33-b1a4-0ae54c0d46c7"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2><span style=\\\"color: var(--dark-green)\\\">H2 heading title</span></h2>\"}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Venenatis in tellus vestibulum netus, tristique pharetra. Phasellus sem dui diam quisque a platea cubilia. Venenatis vestibulum maecenas aliquet sit rutrum orci erat habitant libero. Arcu nisi pretium dictumst malesuada; efficitur porta magnis nascetur magna</p>\"}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"More info button\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__green-outline\",\"textColour\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "4_rte",
        "layout": {
          "name": "single-column",
          "displayName": "Single Column",
          "classNames": [
            "single-column",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column"
          }
        },
        "id": "86539a63-87ed-455d-836a-d7a13a28dc9d"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "single-column"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":50,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2>Our services title here</h2>\"}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "5_our_services_header",
        "layout": {
          "name": "single-column",
          "displayName": "Single Column",
          "classNames": [
            "single-column",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "single-column"
          }
        },
        "id": "8e4d8576-6738-48c5-b3ce-181ec9e0f320"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "three-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "three-columns"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"overlay\":\"/files/image%20overlays/Our-services-overlays/HEX%20EFC424%20-%20Design%201.svg\",\"text\":\"<p></p><h4>Live-in introductory care</h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p><p></p>\",\"xRatio\":1,\"yRatio\":1}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":30,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--light-pink)\\\">Live-in introductory care</span></h4>\"}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":30,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__white-outline\",\"textColour\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"overlay\":\"/files/image%20overlays/Our-services-overlays/HEX%20CCD5BD%20-%20Design%202.svg\",\"xRatio\":1,\"yRatio\":1}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":30,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--light-pink)\\\">Live-in introductory care</span></h4>\"}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":30,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__white-outline\",\"textColour\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"overlay\":\"/files/image%20overlays/Our-services-overlays/HEX%20792377%20-%20Design%203.svg\",\"xRatio\":1,\"yRatio\":1}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":30,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--light-pink)\\\">Live-in introductory care</span></h4>\"}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":30,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__white-outline\",\"textColour\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          }
        ],
        "name": "6_our_services_body",
        "layout": {
          "name": "three-columns",
          "displayName": "Three Columns 33/33/33",
          "classNames": [
            "three-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "three-columns"
          }
        },
        "id": "4157e549-e59f-4da7-ab51-90a2f9b03c33"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/video/v1.0.0/Video",
            "fields": "{\"autoplay\":true,\"controls\":true,\"elementId\":\"\",\"hero\":false,\"href\":\"\",\"loop\":true,\"mute\":true,\"videoPlaceholder\":null,\"videoUrl\":\"https://vimeo.com/1049215359\"}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "7_large_video",
        "layout": {
          "name": "single-column",
          "displayName": "Single Column",
          "classNames": [
            "single-column",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column"
          }
        },
        "id": "c8b000e7-3f6d-4fc1-b549-f67d2ee2f236"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "inherit",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Long headline to lines to turn your visitors</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"height\":20,\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Venenatis in tellus vestibulum netus, tristique pharetra. Phasellus sem dui diam quisque a platea cubilia. Venenatis vestibulum maecenas aliquet sit rutrum orci erat habitant libero. Arcu nisi pretium dictumst malesuada; efficitur porta magnis nascetur magna</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"height\":40,\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"CTA Button\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__dark-green\",\"textColour\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/video/v1.0.0/Video",
            "fields": "{\"autoplay\":false,\"controls\":true,\"elementId\":\"\",\"hero\":false,\"href\":\"\",\"loop\":false,\"mute\":false,\"videoPlaceholder\":null,\"videoUrl\":\"https://vimeo.com/1049215359\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "8_video_with_text",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "inherit",
            "layout": "two-columns"
          }
        },
        "id": "888bf852-f1cb-4883-bd24-b022e8ecde7c"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2 style=\\\"text-align: center\\\"><span style=\\\"color: var(--dark-green)\\\">Your care journey</span></h2>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/your_care_journey/v1.0.0/YourCareJourney",
            "fields": "{\"entries\":[{\"description\":\"<h4 style=\\\"text-align: center\\\"><strong>Speak to our</strong><br><strong>care advisor</strong></h4><p style=\\\"text-align: center\\\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\",\"icon\":\"/files/icons/round/Call%20us-%20Talk%20to%20our%20Care%20Advisor%203_CIRCLE.svg\"},{\"description\":\"<h4 style=\\\"text-align: center\\\"><strong>Speak to our</strong><br><strong>care advisor</strong></h4><p style=\\\"text-align: center\\\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\",\"icon\":\"/files/icons/round/Expert%20care%20+%20support,%20dedicated%20to%20you_CIRCLE.svg\"},{\"description\":\"<h4 style=\\\"text-align: center\\\"><strong>Speak to our</strong><br><strong>care advisor</strong></h4><p style=\\\"text-align: center\\\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\",\"icon\":\"/files/icons/round/Highly%20trained%20nurses%20and%20carers%20_CIRCLE.svg\"}],\"lineColor\":\"var(--dark-green)\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Enquire now\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__yellow\",\"textColour\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "your_care_journey",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column-double-width"
          }
        },
        "id": "e7c1b49f-ad6b-4d0e-a55c-0e627a89fbd9"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2 style=\\\"text-align: center\\\"><span style=\\\"color: var(--light-pink)\\\">Your care journey</span></h2>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/your_care_journey/v1.0.0/YourCareJourney",
            "fields": "{\"entries\":[{\"description\":\"<h4 style=\\\"text-align: center\\\"><strong>Speak to our</strong><br><strong>care advisor</strong></h4><p style=\\\"text-align: center\\\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\",\"icon\":\"/files/icons/round/Call%20us-%20Talk%20to%20our%20Care%20Advisor%203_CIRCLE.svg\"},{\"description\":\"<h4 style=\\\"text-align: center\\\"><strong>Speak to our</strong><br><strong>care advisor</strong></h4><p style=\\\"text-align: center\\\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\",\"icon\":\"/files/icons/round/Expert%20care%20+%20support,%20dedicated%20to%20you_CIRCLE.svg\"},{\"description\":\"<h4 style=\\\"text-align: center\\\"><strong>Speak to our</strong><br><strong>care advisor</strong></h4><p style=\\\"text-align: center\\\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\",\"icon\":\"/files/icons/round/Highly%20trained%20nurses%20and%20carers%20_CIRCLE.svg\"}],\"lineColor\":\"var(--light-pink)\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Enquire now\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__yellow\",\"textColour\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "your_care_journey_alt",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "single-column-double-width"
          }
        },
        "id": "f65c6306-f8d2-4f30-b503-5ace6bb50866"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__rounded",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Left-image-overlays/HEX%20005550%20-%20Design%204.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20005550%20-%20Design.svg\",\"xRatio\":1,\"yRatio\":0.8}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--light-pink)\\\">Long headline two lines to turn your visitors</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":\"var(--dark-green)\",\"buttonFunction\":\"\",\"buttonLink\":\"\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__white-outline\",\"textColour\":null}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "12_block_image_left",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__rounded",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "two-columns"
          }
        },
        "id": "d869a4fc-3d5f-4954-b0d0-7f0873c4cdcb"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__rounded",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-left",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Long headline two lines to turn your visitors</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__green-outline\",\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Long headline two lines to turn your visitors</span></h3>\",\"textColour\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Right-image-overlays/HEX%20FDE9E3%20-%20Design%203.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20FDE9E3%20-%20Design.svg\",\"xRatio\":1,\"yRatio\":0.8}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "13_block_image_right",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__rounded",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-left",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "two-columns"
          }
        },
        "id": "704be5ff-14b4-4c02-b9c3-0cef5037242f"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "classNames": [
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              }
            ],
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4>Rated Excellent by clients and carers</h4>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/html/v1.0.0/Html",
            "fields": "{\"content\":\"<div class=\\\"trustpilot-logo\\\">\\r\\n    <img src=\\\"/files/accreditation%20logos/Group%202901.svg\\\" />\\r\\n</div>\\r\\n\\r\\n<style>\\r\\n    .trustpilot-logo {\\r\\n        text-align: right;\\r\\n    }\\r\\n\\r\\n    @media (max-width: 1000px) {\\r\\n        .trustpilot-logo {\\r\\n            text-align: left;\\r\\n        }\\r\\n    }\\r\\n</style>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "trustpilot_title",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "classNames": [
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              }
            ],
            "layout": "two-columns"
          }
        },
        "id": "a96fb54e-e604-4931-893d-606ec1e02a65"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "classNames": [
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              }
            ],
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":1}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/external_plugin/v1.0.0/ExternalPlugin",
            "fields": "{\"async\":true,\"element\":\"<div id=\\\"trustbox\\\" class=\\\"trustpilot-widget\\\" data-locale=\\\"en-GB\\\" data-template-id=\\\"54ad5defc6454f065c28af8b\\\" data-businessunit-id=\\\"61ead408b418e1a4325f2df6\\\" data-style-height=\\\"240px\\\" data-style-width=\\\"100%\\\" data-theme=\\\"light\\\" data-stars=\\\"4,5\\\" data-review-languages=\\\"en\\\">\\n  <a href=https://uk.trustpilot.com/review/consultuscare.com target=\\\"_blank\\\" rel=\\\"noopener\\\">Trustpilot</a>\\n</div>\",\"elementId\":\"trustbox\",\"isTrustpilot\":true,\"jsClass\":\"\",\"src\":\"https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "15_trustpilot_body",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "classNames": [
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              }
            ],
            "layout": "single-column-double-width"
          }
        },
        "id": "cfddfa13-8ab0-4dd4-97df-3ba769f6dd6a"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/external_plugin/v1.0.0/ExternalPlugin",
            "fields": "{\"async\":true,\"element\":\"<div class='tg-review-carousel-widget-container' id='tgrw-5e969ebf'></div>\",\"elementId\":\"\",\"isTrustpilot\":false,\"jsClass\":\"tg-review-carousel-widget\",\"src\":\"https://api.homecare.co.uk/assets/js/review_widget_carousel.js?displaydiv=tgrw-5e969ebf&displayid=65432181017&displaycontent=snippet&displaywidth=auto&displaycount=12&displayscore=true&displaylink=false&displayborder=true&displaybackgroundcolor=faded&displaypagination=false&displaystrapline=true&displayfontsize=default&displayminoverallrating=0&displayallratings=false&displaylogo=true&displaywrappers=true&displaybutton=true&displaysettingname=true&displayratingreview=true&linksnofollow=false\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "16_homecare",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "layout": "single-column-double-width"
          }
        },
        "id": "63740b72-9ef3-49ff-9252-fd67033e7180"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/carousel/v2.0.0/Carousel",
            "fields": "{\"arrowBackgroundColour\":\"#ffffff\",\"arrowColour\":\"#000000\",\"arrowHeight\":50,\"arrowOpacity\":1,\"autoplay\":false,\"autoplaySpeed\":3000,\"backgroundColour\":\"#ffffff\",\"borderRadius\":0,\"breakpoint\":\"\",\"breakpointClass\":\"\",\"effect\":\"slide\",\"elementId\":\"\",\"height\":null,\"hideArrowsMobile\":false,\"href\":\"\",\"imageFit\":\"contain\",\"loop\":false,\"marquee\":true,\"opacity\":1,\"padding\":0,\"roundedArrows\":false,\"showArrows\":false,\"showPagination\":false,\"showThumbnails\":false,\"slides\":[{\"alt\":\"\",\"expanded\":false,\"showText\":false,\"src\":\"/files/accreditation%20logos/CQC%20logo%20(2).png?aspect-ratio=131%3A89\",\"textBoxPosition\":\"middle-center\",\"type\":\"image\",\"url\":\"\"},{\"alt\":\"\",\"expanded\":false,\"showText\":false,\"src\":\"/files/accreditation%20logos/Group%202901.svg\",\"textBoxPosition\":\"middle-center\",\"type\":\"image\",\"url\":\"\"},{\"alt\":\"\",\"expanded\":false,\"showText\":false,\"src\":\"/files/accreditation%20logos/Layer%202.svg\",\"textBoxPosition\":\"middle-center\",\"type\":\"image\",\"url\":\"\"},{\"alt\":\"\",\"expanded\":false,\"showText\":false,\"src\":\"/files/accreditation%20logos/logo-1.svg\",\"textBoxPosition\":\"middle-center\",\"type\":\"image\",\"url\":\"\"},{\"alt\":\"\",\"expanded\":false,\"showText\":false,\"src\":\"/files/accreditation%20logos/skills-for-care-log0.png?aspect-ratio=24%3A11\",\"textBoxPosition\":\"middle-center\",\"type\":\"image\",\"url\":\"\"}],\"slidesPerView\":5,\"spaceBetween\":60,\"textColour\":\"#000000\",\"transitionSpeed\":5000,\"width\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "awards",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "",
            "layout": "single-column-double-width"
          }
        },
        "id": "041861b6-a8bf-4896-b909-a8c0df545fb6"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "py-8",
                "icon": "SM",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "inherit",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--yellow)\\\">Looking for care?</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--white)\\\">01732 448429</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--peach)\\\">Become a carer</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--white)\\\">01732 XXXXX</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "18_looking_for_care_become_a_carer",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "py-8",
                "icon": "SM",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "inherit",
            "layout": "two-columns"
          }
        },
        "id": "c0aeb874-fb26-4cbe-9743-8dab0af731a2"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "25-50-25",
          "fields": {
            "backgroundColour": "var(--yellow)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "25-50-25"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/icons/round/Call%20us-%20Talk%20to%20our%20Care%20Advisor%203_CIRCLE.svg\",\"newTab\":false,\"objectFit\":\"\",\"width\":\"180\"}",
            "nodeName": "main-content-25-50-25-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Call out friendly team today</span></h3>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Urna morbi in lectus semper conubia. Efficitur netus conubia donec consectetur molestie; sollicitudin pharetra. Eu ultrices cubilia aptent habitasse fermentum</p>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"01732 XXXXXXX\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__dark-green\",\"textColour\":null}",
            "nodeName": "main-content-25-50-25-column-3",
            "rowName": "column-3"
          }
        ],
        "name": "19_cta_block_call_us",
        "layout": {
          "name": "25-50-25",
          "displayName": "Three Columns 25/50/25",
          "classNames": [
            "quarter-half-quarter",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-50"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--yellow)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "25-50-25"
          }
        },
        "id": "ca5638e9-1223-412c-bb39-b0f9ea398577"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "25-50-25",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "25-50-25"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/icons/round/Book%20an%20assessment_CIRCLE.svg\",\"newTab\":false,\"objectFit\":\"\",\"width\":\"180\"}",
            "nodeName": "main-content-25-50-25-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--light-pink)\\\">Book your assignment</span></h3>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Urna morbi in lectus semper conubia. Efficitur netus conubia donec consectetur molestie; sollicitudin pharetra. Eu ultrices cubilia aptent habitasse fermentum</p>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"CTA button\",\"customFunction\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__light-pink\",\"text\":\"<h3><span style=\\\"color: var(--light-pink)\\\">Call out friendly team today</span></h3>\",\"textColour\":null}",
            "nodeName": "main-content-25-50-25-column-3",
            "rowName": "column-3"
          }
        ],
        "name": "20_cta_block_book_an_assignment",
        "layout": {
          "name": "25-50-25",
          "displayName": "Three Columns 25/50/25",
          "classNames": [
            "quarter-half-quarter",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-50"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "25-50-25"
          }
        },
        "id": "59874d98-6a67-4a2f-a8aa-61e17aa97459"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "25-50-25",
          "fields": {
            "backgroundColour": "var(--purple)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "25-50-25"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/icons/round/Call%20us-%20Talk%20to%20our%20Care%20Advisor%203_CIRCLE.svg\",\"newTab\":false,\"objectFit\":\"\",\"width\":\"180\"}",
            "nodeName": "main-content-25-50-25-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--light-pink)\\\">Schedule a call</span></h3>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Urna morbi in lectus semper conubia. Efficitur netus conubia donec consectetur molestie; sollicitudin pharetra. Eu ultrices cubilia aptent habitasse fermentum</p>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"01732 XXXXXXX\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__light-pink\",\"textColour\":null}",
            "nodeName": "main-content-25-50-25-column-3",
            "rowName": "column-3"
          }
        ],
        "name": "21_cta_block_schedule_call",
        "layout": {
          "name": "25-50-25",
          "displayName": "Three Columns 25/50/25",
          "classNames": [
            "quarter-half-quarter",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-50"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--purple)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "25-50-25"
          }
        },
        "id": "96a1847b-a256-4c03-8473-585cb30ca05a"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "25-50-25",
          "fields": {
            "backgroundColour": "var(--peach)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "25-50-25"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/icons/round/Interview_CIRCLE.svg\",\"newTab\":false,\"objectFit\":\"\",\"width\":\"180\"}",
            "nodeName": "main-content-25-50-25-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Become a carer</span></h3>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Urna morbi in lectus semper conubia. Efficitur netus conubia donec consectetur molestie; sollicitudin pharetra. Eu ultrices cubilia aptent habitasse fermentum</p>\"}",
            "nodeName": "main-content-25-50-25-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"01732 XXXXXXX\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__dark-green\",\"textColour\":null}",
            "nodeName": "main-content-25-50-25-column-3",
            "rowName": "column-3"
          }
        ],
        "name": "22_cta_block_become_a_carer",
        "layout": {
          "name": "25-50-25",
          "displayName": "Three Columns 25/50/25",
          "classNames": [
            "quarter-half-quarter",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-50"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column",
                  "col-25"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--peach)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "25-50-25"
          }
        },
        "id": "f124af6f-8fad-47bd-98a5-90584cbf3cfc"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Download our brochure</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>To find out more about our award-winning live-in care services, download our brochure below.</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/contact/v1.0.0/Contact",
            "fields": "{\"campaignMonitorListKey\":\"\",\"emailTemplateId\":\"2b47464a-9482-4347-a2f2-506c832a60ed\",\"items\":[{\"id\":\"33f8c39d-7e8d-4197-83b0-a80d013ae24e\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Name\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"text\"},{\"id\":\"e49cd170-ecc5-4681-8532-725df83f50d5\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Email\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"email\"},{\"id\":\"8c92acf8-2f84-4b4e-9992-c0eb787e93c7\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Telephone number\",\"options\":[],\"placeholder\":\"\",\"required\":false,\"type\":\"tel\"},{\"id\":\"996e0362-d95d-4950-9855-305e0ca14973\",\"initial\":{\"data\":\"<p>By submitting this form, you acknowledge that you have read and understood Consultus' privacy policy.</p>\",\"type\":\"html\"},\"label\":\"\",\"options\":[],\"placeholder\":\"<p>By submitting this form, you acknowledge that you have read and understood Consultus' privacy policy.</p>\",\"required\":true,\"type\":\"allowLogging\"}],\"storeInCRM\":false,\"submitCaption\":\"Download brochure\",\"successRedirectUrl\":\"/download_brochure\",\"title\":\"\",\"toAddress\":\"\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p style=\\\"text-align: center\\\">Consultus brochure image<br>will be uploaded into this<br>area on the build of the site,<br>when new branding brochure<br>has been completed.</p>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "brochure",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "two-columns"
          }
        },
        "id": "306e18c5-f11d-4fb5-9eac-be66ea34659a"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--light-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__column-media-grow",
                "type": "custom"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-left",
                "type": "custom"
              }
            ],
            "fontColour": "inherit",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2><span style=\\\"color: var(--dark-green)\\\">Contact the team today</span></h2>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><strong>Call: 01732 448429</strong></h4><h4><strong>Existing clients call: 01732 XXXXXX</strong></h4>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Alternatively, to arrange your live-in care home assessment, please get in touch using our enquiry form. Fill in your details below, click submit and a member of the team will be in touch.</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/contact/v1.0.0/Contact",
            "fields": "{\"campaignMonitorListKey\":\"\",\"emailTemplateId\":\"2b47464a-9482-4347-a2f2-506c832a60ed\",\"items\":[{\"id\":\"b3722659-9a5b-4219-a3a9-9072fdbffb1f\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Im enquiring about care for:\",\"options\":[{\"label\":\"A loved one\",\"value\":\"A loved one\"},{\"label\":\"Myself\",\"value\":\"Myself\"}],\"placeholder\":\"\",\"required\":false,\"type\":\"radio\"},{\"id\":\"a719989f-d4c7-41d3-b31e-da8d6f202668\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Name\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"text\"},{\"id\":\"9d03e3f3-aa60-4ac1-bd5c-e4a5ac660b9f\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Email\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"text\"},{\"id\":\"8860ebdb-0fbe-411f-91ca-800c571d46ac\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Telephone Number\",\"options\":[],\"placeholder\":\"\",\"required\":false,\"type\":\"text\"},{\"id\":\"260134a6-ebba-41bb-8379-c1e586314a05\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Enquiry\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"textarea\"},{\"id\":\"fd7bf360-2ec8-4862-92b4-41351f2c75e2\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"\",\"options\":[{\"label\":\"By submitting this form, you acknowledge that you have read and understood Consultus’ privacy policy.\",\"value\":\"By submitting this form, you acknowledge that you have read and understood Consultus’ privacy policy.\"}],\"placeholder\":\"\",\"required\":true,\"type\":\"checkbox\"}],\"storeInCRM\":false,\"submitCaption\":\"Submit Form\",\"successRedirectUrl\":\"\",\"title\":\"\",\"toAddress\":\"\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://images.unsplash.com/photo-1731399318229-8da0b83a11cf?q=80&w=2075&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Right-image-overlays/HEX%20CCD5BD%20-%20Design%201.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20CCD5BD%20-%20Design.svg\",\"xRatio\":1,\"yRatio\":1}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "24_contact_the_team_today",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__column-media-grow",
                "type": "custom"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-left",
                "type": "custom"
              }
            ],
            "fontColour": "inherit",
            "layout": "two-columns"
          }
        },
        "id": "fe6125a5-2010-4d10-b3a1-55d641e25732"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "forty-sixty",
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "forty-sixty"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"newTab\":false,\"objectFit\":\"cover\",\"width\":\"250\"}",
            "nodeName": "main-content-forty-sixty-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Content authored by XXXXXX</span></h3>\"}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum odor amet, consectetuer adipiscing elit. Venenatis in tellus vestibulum netus, tristique pharetra. Phasellus sem dui diam quisque a platea cubilia. Venenatis vestibulum maecenas aliquet sit rutrum orci erat habitant libero. Arcu nisi pretium dictumst malesuada; efficitur porta magnis nascetur magna</p>\"}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Meet the team\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__dark-green\",\"textColour\":null}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "25_content_authored_by",
        "layout": {
          "name": "forty-sixty",
          "displayName": "Two Columns 40/60",
          "classNames": [
            "forty-sixty",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-40"
                ]
              },
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-60"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "forty-sixty"
          }
        },
        "id": "19d695b3-68f2-4dfe-b2d4-b1ce430d4f12"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              }
            ],
            "fontColour": "",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Latest blog posts</span></h3>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/blog_list/v2.0.0/BlogList",
            "fields": "{\"categoryId\":\"\",\"postCount\":10,\"showCategories\":true,\"showDate\":true,\"showFilters\":false,\"showPagination\":true,\"showSummary\":true,\"showThumbnails\":true}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "blog_list",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              }
            ],
            "fontColour": "",
            "layout": "single-column-double-width"
          }
        },
        "id": "0b38526d-d8dd-495e-9558-71060303df20"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "classNames": [
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              }
            ],
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Lates blog posts</span></h3>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/blog_list/v2.0.0/BlogList",
            "fields": "{\"categoryId\":\"\",\"elementId\":\"\",\"href\":\"\",\"postCount\":10,\"showCategories\":true,\"showDate\":true,\"showFilters\":true,\"showPagination\":true,\"showSummary\":false,\"showThumbnails\":true}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "blog_list_filer",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "classNames": [
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              }
            ],
            "layout": "single-column-double-width"
          }
        },
        "id": "bdd44ec4-2b81-4964-b938-68b3b1f24161"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "thirty-seventy",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "inherit",
            "layout": "thirty-seventy"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Find out more about our live-in care plans</span></h3>\"}",
            "nodeName": "main-content-thirty-seventy-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/faq/v1.0.0/Faq",
            "fields": "{\"answerColour\":\"\",\"bgColour\":\"\",\"elementId\":\"\",\"entries\":[{\"answer\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>\",\"id\":\"09c0ef06-a973-4389-82a5-9fb44dfab64f\",\"question\":\"What is live in care?\"},{\"answer\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>\",\"id\":\"b3ba7152-fc69-4426-b1df-a30d0f53e196\",\"question\":\"FAQ question to go here?\"},{\"answer\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>\",\"id\":\"f253ba50-c1f8-49f4-bea2-31f71fbe5f3d\",\"question\":\"FAQ question to go here?\"},{\"answer\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>\",\"id\":\"4eed8955-a8bd-49e4-8a44-7e6923645335\",\"question\":\"FAQ question to go here?\"},{\"answer\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>\",\"id\":\"b4f21938-9f6e-4f14-bdc8-234c18f2370d\",\"question\":\"FAQ question to go here?\"},{\"answer\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>\",\"id\":\"bdadf895-01aa-4310-acd7-55e0bf7e7695\",\"question\":\"FAQ question to go here?\"}],\"href\":\"\",\"questionColour\":\"var(--black)\",\"questionElement\":\"h4\"}",
            "nodeName": "main-content-thirty-seventy-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "28_faq",
        "layout": {
          "name": "thirty-seventy",
          "displayName": "Two Columns 30/70",
          "classNames": [
            "thirty-seventy",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-30"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-70"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "inherit",
            "layout": "thirty-seventy"
          }
        },
        "id": "b87e1e9f-8218-4a23-a1d0-6eeaa4f5e8e0"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "forty-sixty",
          "fields": {
            "backgroundColour": "var(--yellow)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "inherit",
            "layout": "forty-sixty"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Subscribe to our newsletter</span></h3>\"}",
            "nodeName": "main-content-forty-sixty-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-forty-sixty-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt sed do eiusmod.</p>\"}",
            "nodeName": "main-content-forty-sixty-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "consultus/plugins/consultus_newsletter/v1.0.0/ConsultusNewsletter",
            "fields": "{\"description\":\"\",\"failure\":\"There was an error processing your subscription.\",\"inputLabel\":\"Email\",\"listKey\":\"123\",\"mailchimpListKey\":\"\",\"nameLabel\":\"Name\",\"policyLink\":\"#\",\"submitCaption\":\"Subscribe\",\"success\":\"Thank you for signing up to our newsletter.\",\"tacLink\":\"#\"}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "newsletter",
        "layout": {
          "name": "forty-sixty",
          "displayName": "Two Columns 40/60",
          "classNames": [
            "forty-sixty",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-40"
                ]
              },
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-60"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--yellow)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "inherit",
            "layout": "forty-sixty"
          }
        },
        "id": "a921be27-9bc0-41a9-861d-ec46e1a69d36"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/icon_text_list/v1.0.0/IconTextList",
            "fields": "{\"elementId\":\"\",\"entries\":[{\"description\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Established and trusted</span></h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod.</p>\",\"icon\":\"/files/icons/round/Call%20us-%20Talk%20to%20our%20Care%20Advisor%203_CIRCLE.svg\",\"id\":\"18b05222-f4d7-4658-95e2-c771fba2da42\"},{\"description\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Choice and control</span></h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod.</p>\",\"icon\":\"/files/icons/round/Family-founded%20and%20family-owned%20_CIRCLE.svg\",\"id\":\"93d53983-e912-4508-99c4-83e916554797\"},{\"description\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Exceptional care</span></h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod.</p>\",\"icon\":\"/files/icons/round/Highly%20trained%20nurses%20and%20carers%20_CIRCLE.svg\",\"id\":\"f7b096d4-cb5b-49ea-8432-4f229dbec2d6\"},{\"description\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Accredited market leading training</span></h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod.</p>\",\"icon\":\"/files/icons/round/Longest-established%20+%20most%20trusted%20_CIRCLE.svg\",\"id\":\"534ac266-fb68-4cca-8983-4ea9ff40eb21\"},{\"description\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Clinical oversight</span></h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod.</p>\",\"icon\":\"/files/icons/round/Care%20planning_CIRCLE.svg\",\"id\":\"55e78356-26d9-4de5-bc20-61c9f6cffc48\"}],\"href\":\"\",\"title\":\"Why choose Consultus?\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "why_choose_consultus",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column-double-width"
          }
        },
        "id": "bd289f48-d22c-4d07-b4d1-8d8f52dbef06"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--cream)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3>Learn more about our care services</h3>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/cta_buttons/v1.0.0/CTAButtons",
            "fields": "{\"buttonStyle\":\"jolojo-custom-button-style__yellow-outline\",\"entries\":[{\"id\":\"5752d4a6-df1f-4547-b730-f0d634b79d4d\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"52256d8a-f05f-444d-85ae-dfae384ece66\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"1b8ec8f3-6bca-4135-8283-9e4000aced44\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"e2ed132e-3624-4b38-91de-826fc1fe9be6\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"749c25b6-a6af-4d89-8d5c-0acda50abb89\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"f27c0c3d-0577-4ba4-b2c6-5934da571313\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"f44b6ca3-62a9-4582-93c0-0bcaeda21347\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false},{\"id\":\"82f5b8cf-5229-43f1-aa99-ad59b3a75312\",\"label\":\"CTA Button\",\"link\":\"#\",\"newTab\":false}]}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "cta_buttons",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-left",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--cream)",
            "layout": "single-column-double-width"
          }
        },
        "id": "9b013189-0534-4f37-abd6-a53df9ed6d17"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--purple)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--cream)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3>Learn more about our care services</h3>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/cta_buttons/v1.0.0/CTAButtons",
            "fields": "{\"buttonStyle\":\"jolojo-custom-button-style__yellow-outline\",\"elementId\":\"\",\"entries\":[{\"id\":\"0cf1fa51-9a87-4325-9d2b-bc3e49cf3bb9\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"1e718943-36ff-4691-a270-c49d6ef5f9ea\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"5244ba5b-b250-42be-8c27-f74b76b84790\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"07407d68-34c4-4b0a-89b2-6848afa1d7d1\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"85021d68-12c6-44b7-8fbe-275e4a486dbf\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"1c7442d2-3096-4541-bb5d-5a7b4f2b2081\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"1ae890f2-b6aa-4306-a91a-3ea6d1877c32\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false},{\"id\":\"21d05c5d-90ce-4e03-9608-2d2f26215511\",\"label\":\"CTA Button\",\"link\":\"\",\"newTab\":false}],\"href\":\"\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "cta_buttons_alt",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--purple)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--cream)",
            "layout": "single-column-double-width"
          }
        },
        "id": "9f61e6c7-ffae-42ca-929e-e89602c305d5"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "forty-sixty",
          "fields": {
            "backgroundColour": "var(--light-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-4",
                "icon": "SM",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "forty-sixty"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1.2},\"imageLink\":\"\",\"imageSrc\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"newTab\":false,\"objectFit\":\"cover\",\"text\":\"<h2 style=\\\"text-align: center\\\"><span style=\\\"color: rgb(0, 0, 0)\\\">\\\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\\\"</span></h2><p style=\\\"text-align: center\\\"></p><p style=\\\"text-align: center\\\"><span style=\\\"color: rgb(0, 0, 0)\\\"><strong>Name goes here</strong></span></p>\",\"width\":\"300\"}",
            "nodeName": "main-content-forty-sixty-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2 style=\\\"text-align: center\\\"><span style=\\\"color: rgb(0, 0, 0)\\\">\\\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\\\"</span></h2>\"}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Name goes here</p>\"}",
            "nodeName": "main-content-forty-sixty-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "38_large_testimonial",
        "layout": {
          "name": "forty-sixty",
          "displayName": "Two Columns 40/60",
          "classNames": [
            "forty-sixty",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-40"
                ]
              },
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-60"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-4",
                "icon": "SM",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "forty-sixty"
          }
        },
        "id": "ddb1a878-ef57-429c-9e25-f34ed87a9a2d"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/testimonials/v3.0.0/Testimonials",
            "fields": "{\"backgroundColour\":\"var(--cream)\",\"elementId\":\"\",\"fontColour\":\"var(--black)\",\"href\":\"\",\"slidesPerView\":3,\"testimonials\":[{\"author\":\"Name here\",\"content\":\"<h4>Highlight phrase pulled from quote below</h4><p>Take courses from the world's best instructors and universities. Courses include recorded auto-graded and peer-reviewed assignments, video lectures, and community discussion forums. When you complete a course, you'll be eligible to receive a shareable electronic Course Certificate for a small fee.</p><p></p>\",\"date\":\"Date here\",\"image\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\"}]}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "39_small_testimonails",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "layout": "single-column-double-width"
          }
        },
        "id": "92d65564-d01b-473b-80b6-c9b3989895c0"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://plus.unsplash.com/premium_photo-1661274147223-116687829d26?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\",\"overlay\":\"/files/image%20overlays/Left-image-overlays/HEX%20005550%20-%20Design%204.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20005550%20-%20Design.svg\",\"xRatio\":\"\",\"yRatio\":\"\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h1>Meet<br>the team</h1>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "40_meet_the_team",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-right",
                "type": "custom"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "id": "e8bb4fad-adc2-4cc5-9b07-06be4dcfe1c6"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--dark-green)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3>Title goes here</h3>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "41_meet_the_team_title",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--dark-green)",
            "layout": "single-column-double-width"
          }
        },
        "id": "1145391d-ae97-477d-8353-2a6feb51e3a6"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "four-columns",
          "fields": {
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              }
            ],
            "layout": "four-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1.2},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"newTab\":false,\"objectFit\":\"cover\",\"width\":\"300\"}",
            "nodeName": "main-content-four-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-four-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Staff name</span></h4>\"}",
            "nodeName": "main-content-four-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Job role</p>\"}",
            "nodeName": "main-content-four-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1.2},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"newTab\":false,\"objectFit\":\"cover\",\"width\":\"300\"}",
            "nodeName": "main-content-four-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-four-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Staff name</span></h4>\"}",
            "nodeName": "main-content-four-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Job role</p>\"}",
            "nodeName": "main-content-four-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1.2},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"newTab\":false,\"objectFit\":\"cover\",\"width\":\"300\"}",
            "nodeName": "main-content-four-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-four-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Staff name</span></h4>\"}",
            "nodeName": "main-content-four-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Job role</p>\"}",
            "nodeName": "main-content-four-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"mx-auto\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1.2},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"newTab\":false,\"objectFit\":\"cover\",\"width\":\"300\"}",
            "nodeName": "main-content-four-columns-column-4",
            "rowName": "column-4"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-four-columns-column-4",
            "rowName": "column-4"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Staff name</span></h4>\"}",
            "nodeName": "main-content-four-columns-column-4",
            "rowName": "column-4"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Job role</p>\"}",
            "nodeName": "main-content-four-columns-column-4",
            "rowName": "column-4"
          }
        ],
        "name": "42_meet_the_team_body",
        "layout": {
          "name": "four-columns",
          "displayName": "Four Columns 25/25/25/25",
          "classNames": [
            "four-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-4",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "classNames": [
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              }
            ],
            "layout": "four-columns"
          }
        },
        "id": "57abb5c7-6b4c-4ba6-ae5e-202eeed30ae8"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "content-width-background",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "jolojo-custom-cb-style__rounded",
                "type": "custom"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4>Connect with us via our social channels and keep up-to-date with our latest content.</h4>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/social_links/v2.0.0/SocialLinks",
            "fields": "{\"customSocials\":[{\"icon\":\"/files/assets/social-icons/facebook.svg\",\"url\":\"#\"},{\"icon\":\"/files/assets/social-icons/instagram.svg\",\"url\":\"#\"},{\"icon\":\"/files/assets/social-icons/linkedin.svg\",\"url\":\"#\"},{\"icon\":\"/files/assets/social-icons/x.svg\",\"url\":\"#\"},{\"icon\":\"/files/assets/social-icons/youtube.svg\",\"url\":\"#\"}],\"fill\":\"var(--light-pink)\",\"size\":55,\"socials\":[{\"display\":false,\"name\":\"facebook\",\"url\":\"\"},{\"display\":false,\"name\":\"x\",\"url\":\"\"},{\"display\":false,\"name\":\"pintrest\",\"url\":\"\"},{\"display\":false,\"name\":\"youtube\",\"url\":\"\"},{\"display\":false,\"name\":\"instagram\",\"url\":\"\"},{\"display\":false,\"name\":\"linkedIn\",\"url\":\"\"}],\"text\":\"<h4>Connect with us via our social channels and keep up-to-date with our latest content.</h4>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "connect_with_us",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "text-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5\" />\n      </svg>\n      ",
                "type": "alignment"
              },
              {
                "class": "content-width-background",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "jolojo-custom-cb-style__rounded",
                "type": "custom"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "id": "8ff2c24f-ee71-4307-a9f8-e9ed61e06fb0"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--purple)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-left",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2>Resources title<br>to go here</h2>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"CTA Button here\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__light-pink\",\"textColour\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":60,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/image_over_image/ImageOverImage",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"image\":\"https://www.consultuscare.com/files/_ECE0173-2.png?size=lg\",\"overlay\":\"/files/image%20overlays/Right-image-overlays/HEX%20792377%20-%20Design%203.svg\",\"overlayMobile\":\"/files/image%20overlays/Mobile-overlays/HEX%20792377%20-%20Design.svg\",\"xRatio\":1,\"yRatio\":0.8}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "resources",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--purple)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "yPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              },
              {
                "class": "items-center",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z\"/></svg>",
                "type": "yAlign"
              },
              {
                "class": "jolojo-custom-cb-style__mobile-reverse",
                "type": "custom"
              },
              {
                "class": "px-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__padding-bottom-mobile",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__padding-left",
                "type": "custom"
              },
              {
                "class": "jolojo-custom-cb-style__image-max-width-mobile",
                "type": "custom"
              }
            ],
            "fontColour": "var(--light-pink)",
            "layout": "two-columns"
          }
        },
        "id": "4a895124-5794-4851-abc0-8fa1bf8aa862"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-4",
                "icon": "SM",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Compare your care options</span></h3>\"}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/comparison_cards/v1.0.0/ComparisonCards",
            "fields": "{\"entries\":[{\"description\":\"Statement 1 to go here\",\"id\":\"4fccce4b-1ee6-4b87-b067-f19faf6fb251\",\"introductory\":true,\"managed\":true},{\"description\":\"Statement 2 to go here\",\"id\":\"b3e08fca-5ff8-462f-82e9-3529118c6f1d\",\"introductory\":true,\"managed\":true},{\"description\":\"Statement 3 to go here\",\"id\":\"b96183f1-9a2f-42b5-bca8-2c64b959cf7a\",\"introductory\":true,\"managed\":true},{\"description\":\"Statement 4 to go here\",\"id\":\"c8b76c24-2e35-4600-82da-2eef031e6404\",\"introductory\":false,\"managed\":true},{\"description\":\"Statement 5 to go here\",\"id\":\"ad7cab11-c9e3-4ae0-98fd-e69301a9a629\",\"introductory\":true,\"managed\":true},{\"description\":\"Statement 6 to go here\",\"id\":\"6377207a-e100-4a42-b3d1-a48161ea8f77\",\"introductory\":false,\"managed\":true},{\"description\":\"Statement 7 to go here\",\"id\":\"4eaec224-47b3-40c0-a6f7-731e6e8eb8d3\",\"introductory\":false,\"managed\":true}],\"left\":{\"label\":\"Introductory care\",\"subHeading\":\"Small summary sentence about Introductory live-in care\"},\"right\":{\"label\":\"Managed care\",\"subHeading\":\"Small summary sentence about Managed live-in care\"}}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "compare_your_options",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-4",
                "icon": "SM",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column-double-width"
          }
        },
        "id": "c2231bf1-df05-46e2-87f6-9d1bb625e91e"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "three-columns",
          "fields": {
            "backgroundColour": "",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "py-8",
                "icon": "SM",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "three-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/assets/yellow_empty.png?aspect-ratio=1%3A1\",\"newTab\":false,\"objectFit\":\"\",\"width\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Flexable grid title</span></h4>\"}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__green-outline\",\"textColour\":null}",
            "nodeName": "main-content-three-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/assets/light_green_empty.png?aspect-ratio=1%3A1\",\"newTab\":false,\"objectFit\":\"\",\"width\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Flexable grid title</span></h4>\"}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__green-outline\",\"textColour\":null}",
            "nodeName": "main-content-three-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/image/v1.0.0/Image",
            "fields": "{\"alignmentClass\":\"\",\"alt\":\"\",\"aspectRatio\":{\"height\":1,\"width\":1},\"elementId\":\"\",\"href\":\"\",\"imageLink\":\"\",\"imageSrc\":\"/files/assets/light_pink_empty.png?aspect-ratio=1%3A1\",\"newTab\":false,\"objectFit\":\"\",\"width\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h4><span style=\\\"color: var(--dark-green)\\\">Flexable grid title</span></h4>\"}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":20,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna sed do eiusmod. Lorem ipsum dolor sit.</p>\"}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"\",\"buttonLink\":\"#\",\"buttonText\":\"Find out more\",\"customFunction\":\"\",\"elementId\":\"\",\"href\":\"\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__green-outline\",\"textColour\":null}",
            "nodeName": "main-content-three-columns-column-3",
            "rowName": "column-3"
          }
        ],
        "name": "46_flexible_items_list",
        "layout": {
          "name": "three-columns",
          "displayName": "Three Columns 33/33/33",
          "classNames": [
            "three-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__rounded-media",
                "type": "custom"
              },
              {
                "class": "py-8",
                "icon": "SM",
                "type": "yPadding"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "three-columns"
          }
        },
        "id": "a46fae16-5670-4a17-a258-dbf3254a09f1"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/jobs/v2.0.0/Jobs",
            "fields": "{\"contracts\":[{\"id\":\"1c84c95c-5a16-47f2-a2b4-0b5a7a509901\",\"value\":\"Full Time\"},{\"id\":\"6bfc5773-0ccf-4415-afa3-1aef1f581bd7\",\"value\":\"Part Time\"}],\"jobs\":[{\"contract\":\"1c84c95c-5a16-47f2-a2b4-0b5a7a509901\",\"description\":\"Subheading to go here\",\"id\":\"b2a1a8d7-ff87-443a-abac-918548dd5a71\",\"link\":\"#\",\"role\":\"f943907a-3479-4250-8b43-ffe31d612469\",\"title\":\"Job title post to be displayed here\",\"type\":\"8764e171-0c2a-4ef8-a699-16d553d752fe\"}],\"roles\":[{\"id\":\"f943907a-3479-4250-8b43-ffe31d612469\",\"value\":\"Live-in Nurse\"}],\"types\":[{\"id\":\"8764e171-0c2a-4ef8-a699-16d553d752fe\",\"value\":\"Nursing care\"}]}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "47_job_search",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column-double-width"
          }
        },
        "id": "197863d6-9ff2-4edb-99ef-c7b4f141897e"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "two-columns",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__contact-us-right-bg",
                "type": "custom"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "two-columns"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h2><span style=\\\"color: var(--light-pink)\\\">Contact us</span></h2>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed.</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"text\":\"<p>sample</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p><strong>Consultus Care and Nursing Ltd Main office</strong><br>17 - 19 London Road<br>Tonbridge<br>Kent<br>TN10 3AB<br><strong>t: 01732 443441</strong><br><strong>e: </strong><a target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\" href=\\\"mailto:care@consultuscare.com\\\"><strong>care@consultuscare.com</strong></a></p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":10,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>To view our other locations, select from the dropdown menu below:</p>\"}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "consultus/plugins/map_with_markers/v1.0.0/MapWithMarkers",
            "fields": "{\"elementId\":\"\",\"href\":\"\",\"places\":[{\"address\":\"17 - 19 London Road Tonbridge Kent TN10 3AB\",\"details\":\"<p></p>\",\"id\":\"248d1d5d-5f6c-488f-8c0f-e46d63d0fc25\",\"name\":\"Our Other Locations\",\"title\":\"Place\"},{\"address\":\"14a Shipbourne Road Tonbridge Kent TN10 3DN\",\"details\":\"<p><strong>Carer House 1</strong><br>14a Shipbourne Road<br>Tonbridge<br>Kent<br>TN10 3DN<br><strong>t: 01732 443441</strong><br><strong>e: space for an email address if needed</strong></p>\",\"id\":\"a0ff84e6-3e30-47e8-8479-5937855ae1cb\",\"name\":\"Carer House 1\",\"title\":\"Place\"}]}",
            "nodeName": "main-content-two-columns-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Send an enquiry</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"height\":30,\"mobileHeight\":null,\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Send an enquiry</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p><span style=\\\"color: var(--black)\\\"><strong>Existing clients call: 01732 XXXXXX</strong></span></p>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"height\":30,\"mobileHeight\":null,\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Send an enquiry</span></h3>\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/contact/v1.0.0/Contact",
            "fields": "{\"campaignMonitorListKey\":\"\",\"emailTemplateId\":\"2b47464a-9482-4347-a2f2-506c832a60ed\",\"items\":[{\"id\":\"ac2d312d-ee87-4f3a-ad73-e51f390a56d5\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"I'm enquiring about care for\",\"options\":[{\"label\":\"A loved one\",\"value\":\"\"},{\"label\":\"Myself\",\"value\":\"\"}],\"placeholder\":\"\",\"required\":true,\"type\":\"radio\"},{\"id\":\"211da2fb-8636-49c3-83be-17e6aab86764\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Name\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"text\"},{\"id\":\"c44f42a4-6716-4cc0-9abd-9ac2af6b1768\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Email\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"email\"},{\"id\":\"7523d8ee-2615-4080-a098-2fe0daec0dfe\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Phone Number\",\"options\":[],\"placeholder\":\"\",\"required\":false,\"type\":\"tel\"},{\"id\":\"fd733ddb-1659-4525-b3f9-593c381a2eee\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Message\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"textarea\"},{\"id\":\"d0ffa912-a8bc-4c12-aba0-af51e1e067b9\",\"initial\":{\"data\":\"<p>By submitting this form, you acknowledge that you have read and understood Consultus' privacy policy.</p>\",\"type\":\"html\"},\"label\":\"\",\"options\":[],\"placeholder\":\"<p>By submitting this form, you acknowledge that you have read and understood Consultus' privacy policy.</p>\",\"required\":true,\"type\":\"allowLogging\"}],\"storeInCRM\":false,\"submitCaption\":\"Submit\",\"successRedirectUrl\":\"\",\"title\":\"\",\"toAddress\":\"\"}",
            "nodeName": "main-content-two-columns-column-2",
            "rowName": "column-2"
          }
        ],
        "name": "48_contact_us_with_map",
        "layout": {
          "name": "two-columns",
          "displayName": "Two Columns 50/50",
          "classNames": [
            "two-columns",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__contact-us-right-bg",
                "type": "custom"
              },
              {
                "class": "items-start",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"h-6 w-6\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z\"/></svg>",
                "type": "yAlign"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "two-columns"
          }
        },
        "id": "7b597ec2-b41a-40da-b897-916e9ddf0763"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column-double-width",
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column-double-width"
          }
        },
        "plugins": [
          {
            "ref": "consultus/plugins/service_search/v2.0.0/ServiceSearch",
            "fields": "{}",
            "nodeName": "main-content-single-column-double-width-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "service_search",
        "layout": {
          "name": "single-column-double-width",
          "displayName": "Single Column Double Width",
          "classNames": [
            "single-column-double-width",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--cream)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              }
            ],
            "fontColour": "var(--black)",
            "layout": "single-column-double-width"
          }
        },
        "id": "a582c293-abab-450f-8424-8a88511b1dc5"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "40-20-20-20",
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "40-20-20-20"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--light-pink)\\\">Areas we cover introdutionary care</span></h3>\"}",
            "nodeName": "main-content-40-20-20-20-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Bedfordshire</p><p>Berkshire</p><p>Bristol</p><p>Buckinghamshire</p><p>Cambridgeshire</p><p>Cheshire</p><p>Cornwall</p><p>Derbyshire</p><p>Devon</p><p>Dorset</p><p>Durham</p><p>East Sussex</p><p>England</p><p>Essex</p>\"}",
            "nodeName": "main-content-40-20-20-20-column-2",
            "rowName": "column-2"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Gloucestershire</p><p>Greater Manchester</p><p>Hampshire</p><p>Herefordshire</p><p>Hertfordshire</p><p>Ireland</p><p>Kent</p><p>Lancashire</p><p>Leicestershire</p><p>Lincolnshire</p><p>London</p><p>Norfolk</p><p>Northumberland</p><p>Nottinghamshire</p>\"}",
            "nodeName": "main-content-40-20-20-20-column-3",
            "rowName": "column-3"
          },
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<p>Oxfordshire</p><p>Rutland</p><p>Scotland</p><p>Shropshire</p><p>Somerset</p><p>Staffordshire</p><p>Suffolk</p><p>Surrey</p><p>Warwickshire</p><p>Wiltshire</p><p>Worcestershire</p><p>Yorkshire</p>\"}",
            "nodeName": "main-content-40-20-20-20-column-4",
            "rowName": "column-4"
          }
        ],
        "name": "50_areas_we_cover_list",
        "layout": {
          "name": "40-20-20-20",
          "displayName": "Four Columns 40/20/20/20",
          "classNames": [
            "forty-twenty-twenty-twenty",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column",
                  "col-40"
                ]
              },
              {
                "name": "column-2",
                "classNames": [
                  "layout-column",
                  "col-20"
                ]
              },
              {
                "name": "column-3",
                "classNames": [
                  "layout-column",
                  "col-20"
                ]
              },
              {
                "name": "column-4",
                "classNames": [
                  "layout-column",
                  "col-20"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--dark-green)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "py-24",
                "icon": "LG",
                "type": "yPadding"
              },
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "my-0",
                "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-6 h-6\">\n        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636\" />\n      </svg>",
                "type": "margin"
              }
            ],
            "fontColour": "var(--white)",
            "layout": "40-20-20-20"
          }
        },
        "id": "af7744a2-1670-478c-9852-989bc1e3dbc5"
      },
      {
        "contentBlock": {
          "nodeName": "main-content",
          "layoutName": "single-column",
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__enquiry-form",
                "type": "custom"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column"
          }
        },
        "plugins": [
          {
            "ref": "core/plugins/text/v2.0.0/Text",
            "fields": "{\"text\":\"<h3><span style=\\\"color: var(--dark-green)\\\">Enquire now</span></h3><p>Please fill out the enquiry form below and we will content you as soon as we are able. If you are looking to work for Consultus please use our <a target=\\\"_self\\\" rel=\\\"noopener noreferrer nofollow\\\" href=\\\"#\\\">job application process</a>.</p>\"}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/contact/v1.0.0/Contact",
            "fields": "{\"campaignMonitorListKey\":\"\",\"emailTemplateId\":\"2b47464a-9482-4347-a2f2-506c832a60ed\",\"items\":[{\"id\":\"84fc1133-49de-49c7-a3e3-d923df203f6d\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Name\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"text\"},{\"id\":\"bbd65d24-eca6-4cbf-8eb4-5fd4997a8740\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Email\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"email\"},{\"id\":\"c62dd145-a509-41c2-b272-1ccf0fa9131a\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Telephone number\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"tel\"},{\"id\":\"60939233-efc3-45a7-b1e6-5810a8f542df\",\"initial\":{\"data\":\"Click here to edit the content\",\"type\":\"html\"},\"label\":\"Details of enquiry\",\"options\":[],\"placeholder\":\"\",\"required\":true,\"type\":\"textarea\"},{\"id\":\"bf22e3b4-239a-4f90-b575-93b9adc4ff23\",\"initial\":{\"data\":\"<p>By submitting this form, you acknowledge that you have<br>read and understood Consultus' privacy policy.</p>\",\"type\":\"html\"},\"label\":\"\",\"options\":[],\"placeholder\":\"<p>By submitting this form, you acknowledge that you have<br>read and understood Consultus' privacy policy.</p>\",\"required\":false,\"type\":\"allowLoggingImplicit\"}],\"storeInCRM\":false,\"submitCaption\":\"Send\",\"successRedirectUrl\":\"\",\"title\":\"\",\"toAddress\":\"\"}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/spacer/v1.0.0/Spacer",
            "fields": "{\"elementId\":\"\",\"height\":40,\"href\":\"\",\"mobileHeight\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          },
          {
            "ref": "core/plugins/button/v2.0.0/Button",
            "fields": "{\"backgroundColour\":null,\"buttonFunction\":\"custom\",\"buttonLink\":\"\",\"buttonText\":\"Submit\",\"customFunction\":\"// This relys on there being only one enquiry form on the page\\r\\ndocument.querySelector('.jolojo-custom-cb-style__enquiry-form form').requestSubmit()\\r\\n\",\"newTab\":false,\"selectedButtonClass\":\"jolojo-custom-button-style__dark-green\",\"textColour\":null}",
            "nodeName": "main-content-single-column-column-1",
            "rowName": "column-1"
          }
        ],
        "name": "enquire now",
        "layout": {
          "name": "single-column",
          "displayName": "Single Column",
          "classNames": [
            "single-column",
            "layout-row"
          ],
          "rows": [
            [
              {
                "name": "column-1",
                "classNames": [
                  "layout-column"
                ]
              }
            ]
          ],
          "fields": {
            "backgroundColour": "var(--light-pink)",
            "backgroundImage": "",
            "backgroundRepeat": "no-repeat",
            "classNames": [
              {
                "class": "max-w-full",
                "icon": "",
                "type": "backgroundWidth"
              },
              {
                "class": "py-16",
                "icon": "MD",
                "type": "yPadding"
              },
              {
                "class": "px-16",
                "icon": "MD",
                "type": "xPadding"
              },
              {
                "class": "jolojo-custom-cb-style__enquiry-form",
                "type": "custom"
              }
            ],
            "fontColour": "inherit",
            "layout": "single-column"
          }
        },
        "id": "8158222d-b8fb-4cbd-a913-43efcaa70045"
      }
    ]
  }
]